import { render, staticRenderFns } from "./Brand_General.vue?vue&type=template&id=68aa37c4&scoped=true&"
import script from "./Brand_General.vue?vue&type=script&lang=js&"
export * from "./Brand_General.vue?vue&type=script&lang=js&"
import style0 from "./Brand_General.vue?vue&type=style&index=0&id=68aa37c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa37c4",
  null
  
)

export default component.exports